import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import LeaveReview from '../Components/Review/LeaveReview'
import HomeContact from '../Components/Home/HomeContact'
import GetReviews from '../Components/Review/GetReviews'

export interface ReviewObj {
  rating: string;
  message: string;
  name: string;
  }
  

const Reviews = () => {
  const [reviews, setReviews] =
    useState <ReviewObj[]> ([])
  
  const baseUrl: string = `${process.env.REACT_APP_URL}`
  return (
    <div className="reviews">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home</title>
        <link rel="canonical" href={baseUrl + '/reviews'} />
      </Helmet>
      <div>
        <GetReviews reviews={reviews} setReviews={setReviews}/>
      </div>
      <div className="bg-image">
        <LeaveReview setReviews={setReviews} />
      </div>
      <div className="bg-image">
        <HomeContact />
      </div>
    </div>
  )
}
export default Reviews

